// removed by extract-text-webpack-plugin
module.exports = {"root":"_2TeICRyc5Do7WZ6OxCMhs4_0","main":"_2YRhtw4VRhYv2C33TYYgyL_0","menuOpen":"_3Xmw0tmqwe6669mF2G4iwz_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e050c68e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TheLayout.vue
// module id = yCaM
// module chunks = 10